<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <div class="m-2">
                <temp-ranking ref="tempRanking"
                              :id="Number(tempRankingId)"
                              :details="details"
                              :eventId="eventId"
                              :canWrite="canWrite"
                              :is-locked-for-edit="isLockedForEdit"
                              @tempRankingReloaded="tempRankingReloaded"
                              @delete="refreshLists">
                </temp-ranking>
            </div>
            <div class="m-2" v-if="loaded">
                <admitted-list ref="admittedList"
                               :tempRankingId="tempRankingId"
                               :eventId="eventId"
                               :details="details"
                               :is-locked-for-edit="isLockedForEdit"
                               @admittedCount="admittedCount"
                               @moveToReserve="moveToReserve"
                               @moveToRejected="moveToRejected"
                               @tempRankingApplied="tempRankingApplied"
                               @delete="refreshLists"
                               @syncWithFormEntityData="refreshLists">
                </admitted-list>
            </div>

            <div class="m-2" v-if="loaded">
                <reserve-list ref="reserveList"
                              :tempRankingId="Number(tempRankingId)"
                              :eventId="eventId"
                              :details="details"
                              :is-locked-for-edit="isLockedForEdit"
                              @reserveCount="reserveCount"
                              @moveToRejected="moveToRejected"
                              @moveToAdmitted="moveToAdmitted"
                              @delete="refreshLists"
                              @syncWithFormEntityData="refreshLists">
                </reserve-list>
            </div>

            <div class="m-2" v-if="loaded">
                <rejected-list ref="rejectedList"
                               :tempRankingId="Number(tempRankingId)"
                               :eventId="eventId"
                               :details="details"
                               :is-locked-for-edit="isLockedForEdit"
                               @rejectedCount="rejectedCount"
                               @moveToReserve="moveToReserve"
                               @moveToAdmitted="moveToAdmitted"
                               @syncWithFormEntityData="refreshLists">
                </rejected-list>
            </div>

            <!--<div>
                <temp-ranking-confirmation-list :registerEntityId="eventId">

                </temp-ranking-confirmation-list>
            </div>-->
        </div>
    </div>
</template>

<script>
    import TempRanking from "../../../components/dynamic/ranking/TempRanking";
    import RejectedList from "../../../components/dynamic/ranking/RejectedList";
    import AdmittedList from "../../../components/dynamic/ranking/AdmittedList";
    import ReserveList from "../../../components/dynamic/ranking/ReserveList";

    export default {
        inject: ['$validator'],
        props: {
            eventId: {
                type: Number,
                default: 0
            },
            details: {
                type: Boolean,
                default: false
            },
            canWrite: {
                type: Boolean,
                default: false
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            }
        },
        components: {
            TempRanking,
            RejectedList,
            AdmittedList,
            ReserveList
        },
        data() {
            return {
                loading: false,
                loaded: false,
                tempRankingId: {
                    type: Number,
                    default: 0
                },
                componentTitle: this.$t('registers.events.evaluation.tempRanking.title'),
                unauthorized: false
            }
        },
        methods: {
            getValidTempRankingIdForTheEvent() {
                this.loading = true;

                this.$http.get(`/api/tempRanking/getValidIdForEvent/${this.eventId}`).then(result => {
                    this.loading = false;
                    let val = Number(result.data.tempRankingId);
                    if (!isNaN(val)) {
                        this.tempRankingId = val;
                    }
                }).catch(error => {
                    this.loading = false;

                    let statusCode = this.$helpers.errorStatusCode(error);
                    if (statusCode === 403) {
                        this.accessDenied();
                        return;
                    }

                    this.$vs.notify({
                        title: this.componentTitle + ' - ' + this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.notificationColor(statusCode),
                        time: this.$store.getters.notificationDuration
                    });
                });

                this.loaded = true;
            },
            refreshLists() {
                this.$refs.admittedList.refresh();
                this.$refs.reserveList.refresh();
                this.$refs.rejectedList.refresh();
            },
            admittedCount(count) {
                this.$refs.tempRanking.setAdmitted(count);
            },
            reserveCount(count) {
                this.$refs.tempRanking.setReserve(count);
            },
            rejectedCount(count) {
                this.$refs.tempRanking.setRejected(count);
            },
            moveToAdmitted() {
                this.refreshLists();
                this.reloadTempRankigStatistics();
            },
            moveToRejected() {
                this.refreshLists();
                this.reloadTempRankigStatistics();
            },
            moveToReserve() {
                this.refreshLists();
                this.reloadTempRankigStatistics();
            },
            reloadTempRankigStatistics() {
                this.$refs.tempRanking.reloadStatistics();
            },
            tempRankingReloaded(id) {
                if (id && this.tempRankingId !== id) {
                    this.setNewTempRankingId(id)
                }
                this.$emit("tempRankingApplied")
                this.refreshLists()
            },
            setNewTempRankingId(id) {
                this.tempRankingId = id;
                this.$refs.admittedList.setTempRankId(id);
                this.$refs.reserveList.setTempRankId(id);
                this.$refs.rejectedList.setTempRankId(id);
            },
            tempRankingApplied() {
                this.refreshLists()
                this.$emit("tempRankingApplied")
            },
            accessDenied() {
                this.unauthorized = true;
            }
        },
        beforeMount() {
            this.getValidTempRankingIdForTheEvent();
        },
        mounted() {
        },
        computed: {
            loadedTempRanking() {
                return !isNaN(this.tempRankingId) &&
                this.tempRankingId !== undefined && this.tempRankingId !== 0;
            }
        }
    }
</script>
